import styled from "styled-components";

const S = {
    PageWrapper: styled.div`
        background: #f8fafc;
        min-height: 100vh;
        padding-bottom: 80px;
    `,
    HeroSection: styled.section`
        background: linear-gradient(135deg, #00A9C4 0%, #00798c 100%);
        padding: 80px 20px;
        text-align: center;
        color: white;

        .hero-content {
            max-width: 800px;
            margin: 0 auto;

            h1 {
                font-size: 3.5em;
                font-weight: 800;
                margin: 0 0 20px 0;
                letter-spacing: -1px;

                @media (max-width: 768px) {
                    font-size: 2.5em;
                }
            }
        }
    `,
    Breadcrumb: styled.div`
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        gap: 10px;
        font-size: 1.1em;
        opacity: 0.9;
        
        a, span {
            color: white;
            text-decoration: none;
            font-weight: 500;
            transition: opacity 0.2s ease;
            
            &:hover {
                opacity: 0.7;
            }
        }
        
        .separator {
            font-size: 0.9em;
            opacity: 0.6;
        }
    `,
    ContentWrapper: styled.div`
        max-width: 1200px;
        margin: -40px auto 0;
        padding: 0 20px;
        position: relative;
        z-index: 10;
        
        .gallery-container {
            background: white;
            border-radius: 24px;
            padding: 50px;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
            border: 1px solid rgba(0,0,0,0.04);
            margin-bottom: 40px;

            @media (max-width: 768px) {
                padding: 30px 20px;
            }

            .intro-text {
                text-align: center;
                margin-bottom: 40px;
                
                p {
                    font-size: 1.2em;
                    line-height: 1.6;
                    color: #334155;
                    margin: 0;
                }
            }

            .mapContainer {
                display: grid;
                grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
                gap: 30px;
                
                @media (max-width: 768px) {
                    grid-template-columns: 1fr;
                }
                
                .video-card {
                    position: relative;
                    background: #000;
                    border-radius: 20px;
                    overflow: hidden;
                    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
                    cursor: pointer;
                    transition: transform 0.3s ease, box-shadow 0.3s ease;
                    height: 250px;

                    &:hover {
                        transform: translateY(-5px);
                        box-shadow: 0 15px 35px rgba(0, 169, 196, 0.25);
                    }
                }

                .iframe-wrapper {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        opacity: 0.8;
                        transition: opacity 0.5s ease, transform 0.5s ease;
                    }

                    .gradient-overlay {
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        width: 100%;
                        height: 70%;
                        background: linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0) 100%);
                        pointer-events: none;
                        z-index: 1;
                    }

                    .play-button-overlay {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        width: 64px;
                        height: 64px;
                        background: rgba(0, 169, 196, 0.85);
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: white;
                        box-shadow: 0 4px 15px rgba(0, 169, 196, 0.5);
                        transition: all 0.3s ease;
                        z-index: 2;

                        svg {
                            width: 32px;
                            height: 32px;
                            margin-left: 4px;
                        }
                    }

                    .video-title {
                        position: absolute;
                        bottom: 20px;
                        left: 20px;
                        right: 20px;
                        z-index: 3;

                        h3 {
                            margin: 0;
                            color: #fff;
                            font-size: 1.2em;
                            font-weight: 700;
                            line-height: 1.3;
                            text-shadow: 0 2px 10px rgba(0,0,0,0.5);
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                            overflow: hidden;
                        }
                    }
                    
                    &:hover img {
                        opacity: 1;
                        transform: scale(1.05);
                    }

                    &:hover .play-button-overlay {
                        background: #00A9C4;
                        transform: translate(-50%, -50%) scale(1.1);
                        box-shadow: 0 6px 20px rgba(0, 169, 196, 0.8);
                    }
                }
            }
        }
    `,
    ModalOverlay: styled.div`
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.85);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
        backdrop-filter: blur(5px);
        animation: fadeIn 0.3s ease;

        @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
        }

        .modal-content {
            position: relative;
            width: 90%;
            max-width: 1000px;
            background: #000;
            border-radius: 16px;
            overflow: hidden;
            box-shadow: 0 0 40px rgba(0, 169, 196, 0.4);
            animation: slideUp 0.4s ease;

            @keyframes slideUp {
                from { transform: translateY(50px); opacity: 0; }
                to { transform: translateY(0); opacity: 1; }
            }
        }

        .close-btn {
            position: absolute;
            top: 15px;
            right: 15px;
            background: rgba(255, 255, 255, 0.2);
            border: none;
            color: white;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            z-index: 10;
            transition: all 0.3s ease;

            &:hover {
                background: #00A9C4;
                transform: rotate(90deg);
            }

            svg {
                width: 24px;
                height: 24px;
            }
        }

        .modal-video-wrapper {
            position: relative;
            padding-bottom: 56.25%; /* 16:9 Aspect Ratio */
            height: 0;
            
            iframe {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }
        }
    `
};

export default S;